<template>
  <ModalBase show-modal auto-h on-top @close-modal="close" :overlay-scrollb="false" class="finance-invoice-modal">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
            {{ $gettext('FINANCE') }}
        </template>
        <template v-slot:title>
          {{ $gettext('Invoice') }}
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <div v-if="!loading" class="finance-widget-wrap">
        <rabobank-ff
          :mode="widgetMode"
          :kvk-number="(currentCompany.kvk && currentCompany.kvk !== '') ? currentCompany.kvk : undefined"
          :contact-details="widgetContactDetails"
          :invoices="widgetInvoices"
        />
      </div>
    </template>
    <template v-slot:actions v-if="currentUserProfile.show_rabo_notification">
      <div class="finance-modal-actions">
        <GekkoButton
          :href="Urls['accounts_notification_settings']()"
          :text="$gettext('Don\'t show again')"
          variant="link"
          size="sm"
        />
      </div>
    </template>
  </ModalBase>
</template>

<script>
import { mapGetters } from "vuex";
import { splitFullName } from "@/utils/";

import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

import { initWidget, subscribeToWidgetEvents } from '@embedded-banking-fundr/invoice-finance'
import '@embedded-banking-fundr/invoice-finance/dist/style.css'
import FinancingService from "@/store/services/financing.service";

export default {
  name: "InvoiceFinanceModal",
  components: {
    ModalBase,
    TitleBar,
    GekkoButton,
    LoadingSpinner,
  },
  props: {
    invoice: {
      type: Object,
      default: () => {}
    },
    invoicePdf: {
      type: String,
      default: null
    },
    financing: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      loading: true,
      widgetContactDetails: null,
      widgetInvoices: null,
      widgetSubscriptionEvents: null,
      widgetMode: 'production',
      partnerId: 'GEKKO',
      widgetApiKey: 'EiYZaekUICnEt1wCODfbL4g5S6KzZ7wb'
    }
  },
  computed: {
    ...mapGetters({
      currentUserProfile: 'main/getCurrentUserProfile',
      currentCompany: "main/getCurrentCompany",
      currentUser: "main/getCurrentUser"
    })
  },
  mounted () {
    document.body.classList.add('modal-on')

    this.widgetSubscriptionEvents = subscribeToWidgetEvents(({ caseId, event, reason }) => {
      const widget_event = {
        'type': event,
        'caseId': caseId,
        'invoiceId': this.invoice.id,
        'companyId': this.currentCompany.id
      }
      console.log('Rabobank widget event', widget_event)
      if (window.mixpanel) {
        window.mixpanel.track('Rabobank widget event', widget_event)
      }

      if (!this.financing) {
        FinancingService.create({
          status: event,
          invoice: this.invoice.id,
          company: this.currentCompany.id,
          case_id: caseId
        }).then(response => {
          this.$emit("financingCreated", response.data)
        })
      } else {
        FinancingService.update(this.invoice.id, {
          status: event
        })
      }

      if (event === 'error' && reason) {
        // console.log('error:', reason)
        console.log('Rabobank widget error: ' + reason)
        if (window.mixpanel) {
          window.mixpanel.track('Rabobank widget error: ' + reason)
        }
      }
    })
  },
  created () {
    this.setupData()
  },
  beforeDestroy () {
    this.widgetSubscriptionEvents.unsubscribe()
  },
  methods: {
    close () {
      this.$emit('close')
      document.body.classList.remove('modal-on')
    },
    setupData () {
      this.loading = true

      if (this.$route.query.fw_mode === 'sandbox') {
        this.widgetMode = 'sandbox'
        this.partnerId = 'GEKKO'
        this.widgetApiKey = 'kM4befCQapljQYQEOQERwnvdDfHo8Y'
      }

      const username = splitFullName(this.currentUser.profile.full_name)

      this.widgetContactDetails = JSON.stringify({
        name: username.firstName,
        surname: username.surname,
        phone: this.currentCompany.phone_number,
        email: this.currentCompany.created_by.email
      })

      const invoiceUrl = this.invoicePdf

      this.widgetInvoices = JSON.stringify([{
        invoiceNumber: this.invoice.number,
        amount: parseFloat(this.invoice.total_amount),
        issueDate: this.invoice.invoice_date,
        deadlineDate: this.invoice.due_date,
        debtorName: this.invoice.recipient_customer.name,
        debtorKvk: (this.invoice.recipient_customer.kvk && this.invoice.recipient_customer.kvk !== '') ? this.invoice.recipient_customer.kvk : undefined,
        filename: this.invoice.number + '.pdf',
        invoiceUrl: invoiceUrl, // invoice file converted to base64
      }])

      this.loading = false

      initWidget({
        identifier: this.widgetApiKey,
        partner: this.partnerId,
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
invoice-finance {
  --rabobank-color-primary: #22AC8A;
  --rabobank-color-secondary: #37A0CD;
  --rabobank-svg-primary: #22AC8A;
  --rabobank-svg-primary-light: #CEF5EB;
  --rabobank-svg-secondary: #37A0CD;
}
.finance-invoice-modal {
  font-size: 1rem;
  .gk-modal {
    max-width: 600px;

    // height: 100% !important;
    // max-height: 996px;
    // min-height: 731px;

    .modal-content-wrap {
      position: relative;
      .finance-widget-wrap {
        padding: 0;

        // height: 100%;

      }
    }
    .finance-modal-actions {
      display: flex;
      justify-content: center;
      border-top: 1px solid $colorBorderDash;
      padding-top: 1rem;
    }
  }
}
</style>